import Ajax from '@/common/utils/ajax'

export default {
    async getProducts(query) {
        return Ajax.get('/catalog/productlistquery', { params: query })
    },
    async getAllAsFlatTree(payload) {
        return Ajax.get('/api/services/catalog/Category/GetAllAsFlatTree', payload)
    },
    async getCategoryHiearchy(payload) {
        return Ajax.get('/api/services/catalog/Category/GetCategoryHiearchy', payload)
    },
    async getBreadcrumb(categoryId) {
        return Ajax.get('/api/services/catalog/Category/GetBreadcrumb?categoryId=' + categoryId)
    },
    async getCategoriesByParentId(categoryId) {
        return Ajax.get('/api/services/catalog/Category/GetCategoriesByParentId?id=' + categoryId)
    },
}

